import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalComponent } from '@finder/shared/components/modal/modal.component';
import { takeUntil } from 'rxjs/operators';
import cloneDeep from 'lodash-es/cloneDeep';

import { FilterGroup } from '@finder/features/list/components/filters/classes/filter-group.class';
import { FilterEmitterService } from '@finder/shared/services/filter-emitter-service/filter-emitter.service';
import { Facet } from '@finder/shared/services/filter-emitter-service/facet.class';
import { AllFiltersBase } from '@finder/features/list/components/filters/components/all-filters/all-filters-base.class';
import { HeightSliderService } from '@finder/features/list/components/filters/components/height-slider/height-slider.service';
import { CommonModule } from '@angular/common';
import { FilterPillsComponent } from '@finder/shared/components/filters/components/filter-pills/filter-pills.component';
import { HeightSliderComponent } from '../height-slider/height-slider.component';
import { RaCheckboxComponent } from '@finder/shared/components/ra-wrappers/ra-checkbox/ra-checkbox.component';
import { ButtonComponent } from '@finder/shared/components/button/button.component';

@Component({
    selector: 'finder-mobile-all-filters',
    templateUrl: './mobile-all-filters.component.html',
    styleUrls: ['./mobile-all-filters.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FilterPillsComponent,
        HeightSliderComponent,
        RaCheckboxComponent,
        ButtonComponent,
    ]
})
export class MobileAllFiltersComponent extends AllFiltersBase implements OnInit, OnDestroy {

    parentComponent: ModalComponent;
    data: any;
    appliedFacets: Facet[] = [];

    get allFilters(): FilterGroup[] {
        return this._allFilters;
    }

    constructor(
        public filterEmitterService: FilterEmitterService,
        private heightSliderService: HeightSliderService
    ) {
        super(filterEmitterService);
    }

    ngOnInit() {
        this._allFilters = cloneDeep(this.data.allFilters);
        this.appliedFacets = this.data.appliedFacets;
        if (this.appliedFacets) {
            this.appliedFacets.forEach((facet) => this.setFilterGroupState(facet));
        }
        this.filterEmitterService.watchFilter()
            .pipe(takeUntil(this.destroy$))
            .subscribe((facet: Facet) => this.applyFacet(facet));

        this.heightSliderService.facetsChanged()
            .pipe(takeUntil(this.destroy$))
            .subscribe((facets) => {
                facets.forEach((facet) => {
                    this.applyFacet(facet);
                });
            });

        super.ngOnInit();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    clearPills() {
        this.heightSliderService.clearSelectedFacetAndValue();
        this.appliedFacets.forEach(facet => {
            facet.value = false;
            this.filterEmitterService.emitFilter(facet);
        });
    }

    closePill(facet: Facet) {
        facet.value = false;
        this.filterEmitterService.emitFilter(facet);
    }

    dismiss() {
        this.parentComponent.dismiss();
    }

    private applyFacet(facet: Facet) {
        const appliedFacet = this.appliedFacets.find(f => f.equal(facet));

        if (facet.value && !appliedFacet) {
            // add the facet to the facet list if it doesn't exist there and the value is true
            this.appliedFacets.push(facet);
        } else if (!facet.value && appliedFacet) {
            // remove the facet from the list if the value is false
            this.appliedFacets = this.appliedFacets.filter(f => !f.equal(facet));
        }

        this.filterEmitterService.emitFilterList(this.appliedFacets);
    }
}
